"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.KeyboardSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var KeyboardSVG = function KeyboardSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M29,6H3A1,1,0,0,0,2,7V23a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V7A1,1,0,0,0,29,6ZM15,10h2v2H15Zm0,4h2v2H15Zm-4-4h2v2H11Zm0,4h2v2H11ZM9,20H7V18H9Zm0-4H7V14H9Zm0-4H7V10H9Zm12,8H11V18H21Zm0-4H19V14h2Zm0-4H19V10h2Zm4,8H23V18h2Zm0-4H23V14h2Zm0-4H23V10h2Z"
  }));
};
exports.KeyboardSVG = KeyboardSVG;
KeyboardSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(KeyboardSVG);
exports.default = _default;